module.exports = function(users) {
	"use strict";
  users
  .controller('userProfileController', userProfileController)
	userProfileController.$inject = ["$rootScope","$scope","getDataService",'refreshtokenService','API_URL','$http','cleanObj','alertService','serverError','offlineError'];
	
  function userProfileController($rootScope,$scope,getDataService,refreshtokenService,API_URL,$http, cleanObj, alertService,serverError, offlineError) {
    var vmup = this;
    vmup.firstnameRequired = false;
    vmup.lastnameRequired = false;
    vmup.passwordWeakRequired = false;
    vmup.matchedpassword = false;
    vmup.passwordWeak = false;
    vmup.passwordStrong = false;
    vmup.passwordChecked = false;
    $rootScope.hasLoaded = true;
    vmup.selectedPosition = {value:'Novinar'}
    vmup.permisions = true;
    if($rootScope.role_id != 'administrator' && $rootScope.role_id != 'superadmin') {
      vmup.permisions = false;
    }     
    vmup.checkPassword = function(pass) {
      if(pass) {
        vmup.checkPasswordObj = owasp.test(pass);
        if(vmup.checkPasswordObj.strong == false) {
          vmup.passwordWeak = true;
          vmup.passwordStrong = false;
          vmup.passwordChecked = false;
        } else {
          vmup.passwordStrong = true;
          vmup.passwordWeak = false;
          vmup.passwordChecked = true;
        }
        
      }
    }
    var updateUserFunction = function(url) {
      var updateDataUser = {
        'email': vmup.dataUser.email,
        'password': vmup.password,
        'first_name': vmup.dataUser.first_name,
        'last_name' : vmup.dataUser.last_name,
        'role' : vmup.selectedRole.value,
        'status' : parseInt(vmup.selectedStatus.value),
        'position': (vmup.selectedPosition.value !='none')?vmup.selectedPosition.value:'',
        'bio': vmup.dataUser.bio,
        'social': vmup.dataUser.social
      }
      cleanObj.clean(updateDataUser);
      var putFunction = function() { 
        $http.put(url , updateDataUser)
        .success(function (data, status, headers) {
          $rootScope.hasLoaded = true;
          alertService('success','Success ', data.message, 2000);
        })
        .error(function (data, status, header, config) {
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {   
                  putFunction();
                }
              },
              function(error) {
              },
              function(progress) {
               // report progress
            });
          }else if(status ==502) {
            serverError()
          } else {  
            alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.'); 
          }
          $rootScope.hasLoaded = true;
        });
      }
      putFunction();
    }
    vmup.updateUser = function() {
      var validation = true;
      
      if(!vmup.dataUser.first_name) {
        validation = false;
        vmup.firstnameRequired = true;
      } else {
        vmup.firstnameRequired = false;
      }
      if(!vmup.dataUser.last_name) {
        validation = false;
        vmup.lastnameRequired = true;
      } else {
        vmup.lastnameRequired = false;
      }
      if(vmup.password) {
        if(!vmup.passwordChecked) {
          validation = false;
          vmup.passwordWeakRequired = true;
        } else {
          vmup.passwordWeakRequired = false;
        }
        if(!vmup.repeatedpassword) {
          validation = false;
          vmup.repeatpasswordRequired = true; 
        } else {
          vmup.repeatpasswordRequired = false; 
        }
        if(vmup.repeatedpassword != vmup.password) {
          validation = false;
          vmup.matchedpassword = true;
        } else {
          vmup.matchedpassword = false;
        }
      }
      
      if(validation) {
        $rootScope.hasLoaded = false;
        updateUserFunction(API_URL+ "users/"+vmup.dataUser._id);
      }
    }
    var getRoleFunction = function() {
      getDataService.get({param1:'users', param2: 'roles', param3:null}).$promise.then(function(data){
        vmup.roles = data.roles; 
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          return
        }
        if(error.status == 401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
          function(answer) {
            if(answer==200) {
              getRoleFunction();
            }
            // do something
          },
          function(error) {
            // report something
          },
          function(progress) {
           // report progress
          });
        }else if(error.status ==502) {
          serverError()
        } else {
          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
        }
      });
    }
    var getprofileFunction = function() { 
      getDataService.get({param1:'users', param2: 'profile'}).$promise.then(function(dataUser){
        getRoleFunction();
        vmup.dataUser = dataUser;
        vmup.selectedPosition.value = (vmup.dataUser.position)? vmup.dataUser.position:'none'  
        vmup.selectedRole = {value:vmup.dataUser.role._id};
        var statusString = vmup.dataUser.status.toString();
        vmup.selectedStatus ={value:statusString};
        if(vmup.dataUser.status==1) {
          vmup.status = "Yes"
        } else {
          vmup.status = "No"
        }
        vmup.roleName = vmup.dataUser.role.name; 
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          return
        }
        if(error.status ==401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
            function(answer) {
              if(answer==200) {
                getprofileFunction();
              }  
              // do something
            },
            function(error) {
              // report something
            },
            function(progress) {
             // report progress
          });
        } else if(error.status ==502) {
          serverError()
        } else {
          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
        }
      });
    }
    getprofileFunction();
    if(!window.navigator.onLine) {
      offlineError('refresh')
      return
    }
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/usersModule/profile/js/userProfileController.js
// module id = 638
// module chunks = 0